import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const SplashPage = lazy(() => import('../pages/splash/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const EmergencyOrderPage = lazy(() => import('../pages/emergency-order/page'));
const LaundryDetailsPage = lazy(() => import('../pages/laundry-details/page'));
const CreateOrderPage = lazy(() => import('../pages/create-order/page'));
const OrdersPage = lazy(() => import('../pages/orders/page'));
const OrderTrackingPage = lazy(() => import('../pages/order-tracking/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/splash',
    element: <SplashPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/emergency-order',
    element: <EmergencyOrderPage />
  },
  {
    path: '/laundry/:id',
    element: <LaundryDetailsPage />
  },
  {
    path: '/create-order',
    element: <CreateOrderPage />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/order-tracking/:id',
    element: <OrderTrackingPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;